(function(){
  // mobile menu
  var mt=document.querySelector('.menu-toggle'), links=document.getElementById('nav-links');
  if(mt&&links){ mt.addEventListener('click',function(){links.classList.toggle('open');}); }
  // scroll reveal
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  // language/localization auto-submit
  document.querySelectorAll('.loc-form select').forEach(function(s){s.addEventListener('change',function(){s.form.submit();});});
  // product gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var main=document.getElementById('pmain'); if(!main)return;
      main.src=b.getAttribute('data-full');
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('active');});
      b.classList.add('active');
    });
  });
})();
